import { pluck, distinctUntilChanged } from 'rxjs/operators';

/**
 * @param {Observable<playback-web-player.Playback>} playbackUpdate$
 * @return {Observable<number>}
 */

const createMaxTimeStream = playbackUpdate$ =>
    playbackUpdate$
        .pipe(
            pluck('maxTime'),
            distinctUntilChanged()
        );

export default createMaxTimeStream;
